import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { appendToParam } from '../../utils';
import { ClientConfigService } from '../client-config';
import { SkipKidsAndAgeRateFilterService } from '../skip-age-rate-filter.service';
import { KIDS_PROFILE_FILTER_SERVICE, KidsProfileFilterAbstractService } from './kids-profile-filter-abstract.service';
import { shouldCheckKidsToken } from './mpx-http-context-tokens';

@Injectable({ providedIn: 'root' })
export class KidsProfileFilterInterceptor implements HttpInterceptor {
  constructor(
    @Inject(KIDS_PROFILE_FILTER_SERVICE) private readonly kidsProfileFilterService: KidsProfileFilterAbstractService,
    private readonly configService: ClientConfigService,
    private readonly skipAgeRateFilterService: SkipKidsAndAgeRateFilterService
  ) {}

  private readonly kidsFilter = 'osnprogram$kidsContent:true';

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req.clone();
    const shouldCheckKidsFilter = this.skipAgeRateFilterService.shouldSkipFiltering() ? false : req.context.get(shouldCheckKidsToken);
    if (!this.configService.configAvailable$.getValue() || !shouldCheckKidsFilter) {
      return next.handle(request);
    }
    return combineLatest([this.kidsProfileFilterService.isKidsProfileType$, this.kidsProfileFilterService.hasValidProfileState$]).pipe(
      filter(([, hasValidProfileState]) => hasValidProfileState),
      take(1),
      switchMap(([isKidsProfileType]) => {
        let params = request.params;
        if (isKidsProfileType) {
          params = appendToParam(request.params, 'q', ' AND ', this.kidsFilter);
        }

        request = request.clone({ params });
        return next.handle(request);
      })
    );
  }
}
